import {getOutlet, hasOutlet} from 'reconnect.js';

const outletName = 'ApiUtil';

function redirect(url) {
  const {modifyRedirectUrl} =
    (hasOutlet(outletName) && getOutlet(outletName).getValue()) || {};

  if (modifyRedirectUrl) {
    url = modifyRedirectUrl(url);
  }

  window.location.href = url;
}

async function req(
  url_,
  {method = 'GET', headers = {}, data, ...restOptions} = {},
  options = {},
) {
  const {onJson, onError, modifyFetchArgs} =
    (hasOutlet(outletName) && getOutlet(outletName).getValue()) || {};

  const {ignoreOnErrorHook, ignoreStatusCheck} = options;

  let fetchArgs = [
    url_,
    {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      ...(method !== 'GET' && data ? {body: JSON.stringify(data)} : {}),
      ...restOptions,
    },
  ];

  if (modifyFetchArgs) {
    fetchArgs = modifyFetchArgs(...fetchArgs);
  }

  const resp = await fetch(...fetchArgs);

  // take the modified args rather than original ones
  const url = fetchArgs[0];
  const fetchPayload = fetchArgs[1];

  if (ignoreStatusCheck || (200 <= resp.status && resp.status < 400)) {
    try {
      const jsonResp = await resp.json();

      if (typeof onJson === 'function') {
        return onJson(url, fetchPayload, jsonResp);
      } else {
        return jsonResp;
      }
    } catch (ex) {
      // bypass
    }

    // we cannot perform resp.json(), but we still consider it is a success fetch
    // without any payload
    return null;
  }

  if (!ignoreOnErrorHook && typeof onError === 'function') {
    // don't return, so if the hook doesn't throw an exception,
    // the flow will continue to execute
    await onError(url, fetchPayload, resp);
  }

  const err = {status: resp.status, response: undefined};

  try {
    err.response = await resp.json();
  } catch (ex) {
    // bypass
  }

  throw err;
}

export {req, redirect};
